import {
    FETCH_DASHBOARDCOUNT_REQUEST,
    FETCH_DASHBOARDCOUNT_SUCCESS,
    FETCH_DASHBOARDCOUNT_FAILURE,
  } from "./DashboardCountFetchTypes";
  
  const initialState = {
    loading: false,
    dashboardCounts: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DASHBOARDCOUNT_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_DASHBOARDCOUNT_SUCCESS:
        return {
          loading: false,
          dashboardCounts: action.payload,
          error: "",
        };
      case FETCH_DASHBOARDCOUNT_FAILURE:
        return {
          loading: false,
          dashboardCounts: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  